// Internal
import { logger } from '@/lib/logger';
import type { LogOnShippingChangeReceivedToFPTIPayload } from './types';
import { isFunction } from '@/lib/utils/typeUtils';

const logonShippingAddressChangeReceivedToFPTI = (
  payload: LogOnShippingChangeReceivedToFPTIPayload,
): void => {
  const { errorDescription = 'none', status } = payload;
  logger.fpti('checkout_merchant_shipping_calculation_received', {
    api_response: status,
    error_description: errorDescription,
    state_name: 'review',
    transition_name: 'process_review_merchant_shipping_calculation',
  });
};

const logShippingOptionsChangeReceivedToFPTI = (
  payload: LogOnShippingChangeReceivedToFPTIPayload,
): void => {
  const { errorDescription = 'none', status } = payload;
  logger.fpti('checkout_merchant_shipping_option_change_received', {
    api_response: status,
    error_description: errorDescription,
    state_name: 'review',
    transition_name: 'process_review_merchant_shipping_option_calculation',
  });
};

const logShippingCallbacksInfoToFPTI = (): void => {
  logger.fpti('sdk_shipping_callback', {
    event_name: 'sdk_integration_call_received',
    shipping_address_change_callback: isFunction(
      window.xprops?.onShippingAddressChange,
    ),
    shipping_change_callback: isFunction(window.xprops?.onShippingChange),
    shipping_options_change_callback: isFunction(
      window.xprops?.onShippingOptionsChange,
    ),
  });
};

export {
  logonShippingAddressChangeReceivedToFPTI,
  logShippingOptionsChangeReceivedToFPTI,
  logShippingCallbacksInfoToFPTI,
};
